export default {
  BusinessStockDeliveryCom: {
    title: 'View outbound result Order No.',
    code: 'Outbound result Order No.',
  }
};
